var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Litros" } },
          [
            _c("b-form-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                "data-cy": "liters",
                "data-vv-as": "litros",
                name: "liters",
                type: "number",
                state: _vm.errors.has("custom-document-part-5.liters")
                  ? false
                  : null,
                formatter: _vm.maxLength
              },
              model: {
                value: _vm.chargeGasolineForm.liters,
                callback: function($$v) {
                  _vm.$set(_vm.chargeGasolineForm, "liters", $$v)
                },
                expression: "chargeGasolineForm.liters"
              }
            }),
            _vm.errors.has("custom-document-part-5.liters")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to text-left"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first("custom-document-part-5.liters")
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Vale/Factura" } },
          [
            _c("b-form-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                "data-cy": "invoice",
                "data-vv-as": "vale/factura",
                name: "invoice",
                type: "text",
                state: _vm.errors.has("custom-document-part-5.invoice")
                  ? false
                  : null,
                maxLength: "15"
              },
              model: {
                value: _vm.chargeGasolineForm.invoice,
                callback: function($$v) {
                  _vm.$set(_vm.chargeGasolineForm, "invoice", $$v)
                },
                expression: "chargeGasolineForm.invoice"
              }
            }),
            _vm.errors.has("custom-document-part-5.invoice")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to text-left"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first("custom-document-part-5.invoice")
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("InputCurrency", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|min:1",
              expression: "'required|min:1'"
            }
          ],
          attrs: {
            id: "amount",
            name: "amount",
            "data-cy": "amount",
            state: _vm.errors.has("custom-document-part-5.amount")
              ? false
              : null,
            danger: _vm.errors.has("custom-document-part-5.amount"),
            "danger-text": _vm.errors.first("custom-document-part-5.amount"),
            "data-vv-as": "monto"
          },
          model: {
            value: _vm.chargeGasolineForm.amount,
            callback: function($$v) {
              _vm.$set(_vm.chargeGasolineForm, "amount", $$v)
            },
            expression: "chargeGasolineForm.amount"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "KM Carga" } },
          [
            _c(
              "b-input-group",
              { attrs: { append: "KM" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    "data-cy": "kilometer-charge",
                    "data-vv-as": "KM carga",
                    name: "kilometerCharge",
                    type: "number",
                    state: _vm.errors.has(
                      "custom-document-part-5.kilometerCharge"
                    )
                      ? false
                      : null,
                    formatter: _vm.maxLength
                  },
                  model: {
                    value: _vm.chargeGasolineForm.kilometerCharge,
                    callback: function($$v) {
                      _vm.$set(_vm.chargeGasolineForm, "kilometerCharge", $$v)
                    },
                    expression: "chargeGasolineForm.kilometerCharge"
                  }
                })
              ],
              1
            ),
            _vm.errors.has("custom-document-part-5.kilometerCharge")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to text-left"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first(
                              "custom-document-part-5.kilometerCharge"
                            )
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "row align-items-center mt-3" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-md-3 align-items-end" },
          [
            _c("upload-file", {
              attrs: {
                permission: "*",
                accept: "application/pdf, .jpeg, .jpg, .png",
                text: "Seleccionar documento",
                "upload-to": "ed",
                "button-class": {
                  "btn-block": true,
                  "mb-5": _vm.errors.has("custom-document-part-5.fileName")
                },
                "container-class": "w-100"
              },
              on: {
                input: function($event) {
                  return _vm.addFile()
                }
              },
              model: {
                value: _vm.chargeGasolineForm.voucher,
                callback: function($$v) {
                  _vm.$set(_vm.chargeGasolineForm, "voucher", $$v)
                },
                expression: "chargeGasolineForm.voucher"
              }
            })
          ],
          1
        ),
        _vm.chargeGasolineForm.voucher &&
        Object.keys(_vm.chargeGasolineForm.voucher).length
          ? _c("div", { staticClass: "col-md-9" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-row align-items-center" },
                [
                  _c("vs-icon", {
                    attrs: {
                      icon: "description",
                      size: "45px",
                      color: "primary"
                    }
                  }),
                  _c("b", { staticClass: "text-truncate w-100" }, [
                    _vm._v(_vm._s(_vm.chargeGasolineForm.voucher.name))
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "col-md-12" }, [
          !!_vm.error.message
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n              vs-input--text-validation-span v-enter-to text-left"
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "col-md-12 d-flex align-items-end justify-content-end" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "ripple",
                rawName: "v-ripple.400",
                value: "rgba(255, 255, 255, 0.15)",
                expression: "'rgba(255, 255, 255, 0.15)'",
                modifiers: { "400": true }
              }
            ],
            attrs: { "data-cy": "add-charge-button", variant: "primary" },
            on: {
              click: function($event) {
                return _vm.addCharge()
              }
            }
          },
          [_vm._v(" Agregar Carga ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntar Voucher Combustible")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }